module.exports = __webpack_public_path__ + "img/language_logo.eab25347.png";